<template>
  <qx-card title="找油账户">
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            >
              <section  slot-scope="scope">
                <section v-if="scope.column.property === 'acctName'">
                  <span>{{scope.row.acctName}}
                    <span v-if="scope.$index !== 0">（{{scope.row.acctNo}}）</span>
                  </span>
                </section>
                <section
                  v-if="scope.column.property !== 'acctName'"
                  :class="{primary: scope.$index === 0}"
                >
                  {{scope.row[scope.column.property]}}
                </section>
              </section>
            </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  oilAccountDetailList, // 列表
} from 'api/service';
export default {
  mixins: [
    tableMixin,
  ],
  data () {
    return {
      searchBoxData: {
        oilRechargeBillType: 1,
        oilRechargeType: 2,
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'acctName',
            label: '账户',
          },
          {
            prop: 'accountBalanceDouble',
            label: '余额',
          },
          {
            prop: 'distributedAmountDouble',
            label: '已分配(未消费)',
          },
          {
            prop: 'billTypeName',
            label: '票据要求',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: oilAccountDetailList,
  },
  created () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
